import React from 'react';
import cls, { mergeClassNames } from 'js/utils/classNameBuilder.util';
import RaceProperty from '../RaceProperty';
import style from './index.scss';

export const CardActions = ({ className = '', children }) => (
    <div className={`${style.actions} ${className}`}>
        {children}
    </div>
);

export const CardMedia = ({ className = '', children, image }) => (
    <div className={`${style.media} ${className}`} style={{ backgroundImage: image && `url("${image}")` }}>
        {children}
    </div>
);

export const CardBody = ({ className = '', children }) => (
    <div className={`${style.body} ${className}`}>
        {children}
    </div>
);

export const Card = ({ className = '', children, cardRef }) => (
    <div className={`${style.card} ${className}`} ref={cardRef}>
        {children}
    </div>
);

export const CardName = ({ name, className = '', classNames = {} }) => (
    <div className={`${style.cardName} ${className}`}>
        <div className={cls(['text'], style, classNames)}>{name}</div>
    </div>
);

export const CardInfoBlock = ({ label, value, children, className = '', classNames = {} }) => (
    <RaceProperty
        label={label}
        value={value}
        className={`${style.infoBlock} ${className}`}
        classNames={mergeClassNames(['label', 'value'], style, classNames)}>
        {children}
    </RaceProperty>
);

export default Card;
